<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" class="multipleSelectScroll" v-show="showSearch" label-width="80px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="合同编号" prop="contractNum">
            <el-input v-model="queryParams.contractNum" placeholder="请输入合同编号" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="签约客户" prop="customerName">
            <el-input v-model="queryParams.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="5">
          <el-form-item label="商机" prop="businessName">
            <el-input v-model="queryParams.businessName" placeholder="请输入商机名称" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="7">
          <el-form-item label="回款日期" prop="actualFundDate">
            <el-date-picker v-model="queryParams.actualFundDate" value-format="yyyy-MM-dd" type="daterange"
                            range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="mb8">
        <dept-user-select
          ref="deptUserSelectRef"
          :formParam="queryParams"
          dept-label="回款部门"
          user-label="回款人"
        />
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
            <el-button type="warning" icon="el-icon-download" :loading="exporting" :disabled="loading" @click="handleExport">导出</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row style="margin: 10px 0;">
      <el-col :span="24">
        <div style="font-size: 14px; margin: 5px 0">
          <span style="margin-right: 40px">合同总额（元）：{{ amountFormat(otherData.totalContractAmount) }}万</span>
          <span style="margin-right: 40px">回款总额（元）：{{ amountFormat(otherData.totalFundAmount) }}万</span>
        </div>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
      <el-table-column label="合同编号" min-width="110" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractDetail(scope.row)">
            {{ scope.row.contractNum }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="签约客户" min-width="110" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail(scope.row)">
            {{ scope.row.customerName }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="商机名称" min-width="110" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toBusinessDetail(scope.row)">
            {{ scope.row.businessName }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="合同额(元)" width="110" align="center">
        <template slot-scope="scope">
          <span>{{ amountFormat(scope.row.contractAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="回款日期" width="110" align="center" prop="actualFundDate"/>
      <el-table-column label="回款金额(元)" width="110" align="center">
        <template slot-scope="scope">
          <span>{{ amountFormat(scope.row.actualFundAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支付方式" width="100" align="center" prop="payTypeDesc"/>
      <el-table-column label="回款银行" width="100" align="center" prop="bankDesc"/>
      <el-table-column label="备注" min-width="110" align="center" prop="remark"/>
      <el-table-column label="回款部门" width="120" align="center" prop="fundDeptName"/>
      <el-table-column label="回款人" width="110" align="center" prop="managerName"/>
      <el-table-column label="操作" width="120" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text" v-hasPermi="['crm:fundRecord:edit']" @click="handleRecord(scope.row, 'edit')">编辑</el-button>
          <el-button type="text" v-hasPermi="['crm:fundRecord:delete']" @click="handleRecord(scope.row, 'del')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

    <el-dialog title="编辑回款记录" :visible.sync="recordVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="600px">
      <el-form :model="newRecordObj" :rules="recordRules" ref="editRecordForm" label-width="150px">
        <el-form-item label="合同编号:">
          {{ detailInfo.contractNum }}
        </el-form-item>
        <el-form-item label="签约客户:">
          {{ detailInfo.customerName }}
        </el-form-item>
        <el-form-item label="商机:">
          {{ detailInfo.businessName }}
        </el-form-item>
        <el-form-item label="回款日期:" prop="actualFundDate">
          <el-date-picker v-model="newRecordObj.actualFundDate" style="width: 200px" value-format="yyyy-MM-dd" type="date" range-separator="-" placeholder="请选择日期"/>
        </el-form-item>
        <el-form-item label="回款金额（元）:" prop="actualFundAmount">
          <el-input v-model="newRecordObj.actualFundAmount" style="width: 200px" type="number" :maxlength="30" placeholder="请输入回款金额" clearable/>
        </el-form-item>
        <fund-owner-select ref="fundOwnerSelectRef" :form-param="newRecordObj"/>
        <el-form-item label="支付方式:" prop="payType">
          <el-select v-model="newRecordObj.payType" style="width: 200px" filterable placeholder="请选择支付方式">
            <el-option v-for="dict in payTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
          </el-select>
        </el-form-item>
        <el-form-item label="回款银行:" prop="bank">
          <el-select v-model="newRecordObj.bank" style="width: 200px" filterable placeholder="请选择回款银行">
            <el-option v-for="dict in bankOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="500" show-word-limit v-model="newRecordObj.remark" placeholder="请输入500字以内" clearable/>
        </el-form-item>
      </el-form>
      <div slot="footer" align="center" class="dialog-footer">
        <el-button @click="recordVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmInfo()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {delContractFundRecord, exportContractFundRecord, listPageContractFundRecord, updateContractFundRecord} from "@/api/crm/fundRecord";
import {saveAs} from 'file-saver';
import {amountFormat} from '@/utils/index'
import deptUserSelect from "@/views/crm/components/deptUserSelect";
import {mapState} from "vuex";
import FundOwnerSelect from "@/views/crm/fundRecord/fundOwnerSelect";

export default {
  name: "FundRecordManage",
  data () {
    return {
      amountFormat,
      // 遮罩层
      loading: true,
      exporting: false,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      dataList: [],
      otherData: {
        totalContractAmount: 0,
        totalFundAmount: 0
      },
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractNum: null,
        customerName: null,
        deptIdList: [],
        managerIdList: [],
        businessName: null,
        actualFundDate: [],
        actualFundDateStart: null,
        actualFundDateEnd: null
      },
      recordVisible: false,
      detailInfo: {},
      bankOptions: [], // 回款银行
      payTypeOptions: [], // 支付方式
      newRecordObj: {
        recordId: null,
        actualFundDate: null,
        actualFundAmount: null,
        fundDeptId: null,
        fundUserId: null,
        payType: null,
        bank: null,
        remark: ''
      },
      recordRules: {
        payType: [
          {required: true, message: '请选择支付方式', trigger: 'change'}
        ],
        bank: [
          {required: true, message: '请选择回款银行', trigger: 'change'}
        ],
        actualFundAmount: [
          {required: true, message: '请输入回款金额', trigger: 'blur'}
        ],
        actualFundDate: [
          {required: true, message: '请输入回款日期', trigger: 'change'}
        ],
        fundDeptId: [
          {required: true, message: '请选择回款部门', trigger: 'change'}
        ],
        fundUserId: [
          {required: true, message: '请选择回款人', trigger: 'change'}
        ]
      },
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    deptUserSelect,
    FundOwnerSelect
  },
  created () {
    this.queryParams.managerIdList = [this.currentUserId]
    this.getList();
    this.getDicts("bank").then(response => {
      this.bankOptions = response.data;
    });
    this.getDicts("pay_type").then(response => {
      this.payTypeOptions = response.data;
    });
  },
  methods: {
    buildQueryParams () {
      let params = JSON.parse(JSON.stringify(this.queryParams));
      params.actualFundDateStart = null;
      params.actualFundDateEnd = null;
      if (params.actualFundDate && params.actualFundDate.length > 1) {
        params.actualFundDateStart = params.actualFundDate[0]
        params.actualFundDateEnd = params.actualFundDate[1]
      }
      params.actualFundDate = null;
      return params;
    },
    async handleExport () {
      if (this.loading || this.exporting) return;
      const params = this.buildQueryParams();
      delete params.pageNum;
      delete params.pageSize;
      this.exporting = true;
      try {
        const blob = await exportContractFundRecord(params);
        if (!(blob instanceof Blob) || !blob.size) throw new Error('导出失败，请重试');
        if ((blob.type || '').includes('json')) {
          const error = JSON.parse(await blob.text());
          throw new Error(error.msg || '导出失败，请重试');
        }
        saveAs(blob, `回款记录_${this.parseTime(new Date(), '{y}{m}{d}_{h}{i}{s}')}.xlsx`);
      } catch (error) {
        this.$message.error(error.message || '导出失败，请重试');
      } finally {
        this.exporting = false;
      }
    },
    getList () {
      this.loading = true;
      listPageContractFundRecord(this.buildQueryParams()).then(response => {
        this.dataList = response.rows || [];
        this.otherData = response.otherData || {}
        this.total = response.total;
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.resetForm("queryForm");
      this.$refs.deptUserSelectRef.deptSelect()
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange (selection) {
      this.ids = selection.map(item => item.id);
      this.multiple = !selection.length;
    },
    toDetail (row) {
      window.open("/crm/plan-fund/detail/" + row.id, "_blank")
    },
    toContractDetail (row) {
      window.open("/crm/contract/detail/" + row.contractId, "_blank")
    },
    toCustomerDetail (row) {
      window.open("/crm/customer/detail/" + row.customerId, "_blank")
    },
    toBusinessDetail (row) {
      window.open("/crm/business/detail/" + row.businessId, "_blank")
    },
    // 处理回款记录
    handleRecord (row, type) {
      if (type == 'edit') {
        this.newRecordObj = JSON.parse(JSON.stringify(row))
        this.detailInfo.contractNum = row.contractNum
        this.detailInfo.businessName = row.businessName
        this.detailInfo.customerName = row.customerName
        this.recordVisible = true
        this.$nextTick(() => {
          this.$refs.fundOwnerSelectRef.setSelection(row.fundDeptId, row.fundUserId || row.managerId)
        })
      } else {
        this.$confirm('删除后将无法恢复，是否确认删除该记录?', "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
          delContractFundRecord({
            id: row.recordId
          }).then(response => {
            this.$message.success('记录删除成功')
            this.getList()
          }).finally(() => {
            loading.close();
          });
        })
      }
    },
    // 提交
    confirmInfo () {
      this.$refs['editRecordForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
          updateContractFundRecord(this.newRecordObj).then(response => {
            this.recordVisible = false
            this.msgSuccess('操作成功');
            this.getList()
          }).finally(() => {
            loading.close()
          })
        }
      });
    }
  }
};
</script>
